"use client";
import _extends from "@babel/runtime/helpers/esm/extends";
import roLocale from "date-fns/locale/ro";

var Calendar = {
	sunday: "D",
	monday: "L",
	tuesday: "Ma",
	wednesday: "Mi",
	thursday: "J",
	friday: "V",
	saturday: "S",
	ok: "OK",
	today: "astăzi",
	yesterday: "ieri",
	hours: "ore",
	minutes: "minute",
	seconds: "secunde",
	formattedMonthPattern: "MMMM yyyy",
	formattedDayPattern: "dd MMMM yyyy",
	dateLocale: roLocale,
};
var Combobox = {
	noResultsText: "Niciun rezultat",
	placeholder: "Selectează",
	searchPlaceholder: "Caută",
	checkAll: "Toate",
};
export default {
	code: "ro-RO",
	common: {
		loading: "Se încarcă…",
		emptyMessage: "Fără date",
		remove: "Șterge",
		clear: "Golește",
	},
	Plaintext: {
		unfilled: "Necompletat",
		notSelected: "Neselectat",
		notUploaded: "Neîncărcat",
	},
	Pagination: {
		more: "Mai multe",
		prev: "Anterior",
		next: "Următor",
		first: "Primul",
		last: "Ultimul",
		limit: "{0} / pagini",
		total: "Rânduri: {0}",
		skip: "Mergi la: {0}",
	},
	DateTimeFormats: Calendar,
	Calendar: Calendar,
	DatePicker: Calendar,
	DateRangePicker: _extends({}, Calendar, {
		last7Days: "ultimele 7 zile",
	}),
	Combobox: Combobox,
	InputPicker: {
		newItem: "Element nou",
		createOption: 'Creează opțiunea "{0}"',
	},
	TagPicker: {
		newItem: "Element nou",
		createOption: 'Creează opțiunea "{0}"',
	},
	Uploader: {
		inited: "Inițial",
		progress: "Se încarcă",
		error: "Eroare",
		complete: "Finalizat",
		emptyFile: "Gol",
		upload: "Încarcă",
		removeFile: "Șterge fișierul",
	},
	CloseButton: {
		closeLabel: "Închide",
	},
	Breadcrumb: {
		expandText: "Afișează calea",
	},
	Toggle: {
		on: "Pornit",
		off: "Oprit",
	},
};
